var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4679 19.1307C12.5133 19.4707 12.3999 19.8333 12.1393 20.0713C12.0344 20.1764 11.9099 20.2598 11.7728 20.3166C11.6357 20.3735 11.4887 20.4028 11.3403 20.4028C11.1918 20.4028 11.0449 20.3735 10.9078 20.3166C10.7706 20.2598 10.6461 20.1764 10.5413 20.0713L5.99659 15.5267C5.87305 15.4058 5.77912 15.258 5.72211 15.0948C5.66509 14.9317 5.64655 14.7575 5.66792 14.586V8.78333L0.239255 1.836C0.0552113 1.59973 -0.0278331 1.30023 0.00826829 1.00292C0.0443696 0.705615 0.196682 0.434686 0.431922 0.249333C0.647256 0.0906667 0.885256 0 1.13459 0H17.0013C17.2506 0 17.4886 0.0906667 17.7039 0.249333C17.9392 0.434686 18.0915 0.705615 18.1276 1.00292C18.1637 1.30023 18.0806 1.59973 17.8966 1.836L12.4679 8.78333V19.1307ZM3.44659 2.26667L7.93459 8.00133V14.2573L10.2013 16.524V7.99L14.6893 2.26667H3.44659Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconNew);
export default __webpack_public_path__ + "static/media/filterIconNew.101fa3cb616f8ddbee6785ad87d7acd6.svg";
export { ForwardRef as ReactComponent };